import CalendarBody from './CalendarBody';

const View = (props) => <CalendarBody {...props} />;

export default View;
